import initReactApp from 'dpl/util/initReactApp';
import BreedHealthTestTiersContainer from 'dpl/containers/Breeds/HealthTestRequirements/Show/BreedHealthTestTiersContainer';
import BreedHealthTestBreedersContainer from 'dpl/containers/Breeds/HealthTestRequirements/Show/BreedHealthTestBreedersContainer';

initReactApp({
  BreedHealthTestTiersContainer,
  BreedHealthTestBreedersContainer
});
